import i18n from '../../../i18n';
import isEmpty from 'lodash/isEmpty';
import isDecimal from 'validator/lib/isDecimal';
import isNumeric from 'validator/lib/isNumeric';
import moment from 'moment'
export const validate = values => {
    let errors = {specification: {}};

    collectionDate(values, errors);
    collectionPlace(values, errors);
    depositDate(values, errors);
    depositPlace(values, errors);
    vehicleBrand(values, errors)
    vehicleModel(values, errors)
    vehicleRegistrationNumber(values, errors)
    //vehicleCount(values, errors);
    //vehicleType(values, errors);
    //price(values, errors);

    return errors;
};

const collectionDate = (values, errors) => {
    if (isEmpty(values.collectionDate)) {
        return errors.collectionDate = i18n.t('booking.validation_collection_date');
    }
    if (moment(values.collectionDate) <= moment()) {
        return errors.collectionDate = i18n.t('booking.validation_invalid_date');
    }
};

const collectionPlace = (values, errors) => {
    if (!validateFromTo('collectionPlace', values.collectionPlace)) {
        return errors.collectionPlace = i18n.t('booking.validation_collection_place');
    }
};

const depositDate = (values, errors) => {
    if (isEmpty(values.depositDate)) {
        return errors.depositDate = i18n.t('booking.validation_deposit_date');
    }
    if (!isEmpty(values.collectionDate) && values.depositDate<=values.collectionDate) {
        return errors.depositDate = i18n.t('booking.validation_deposit_date_collection_date');
    }
};

const depositPlace = (values, errors) => {
    if (!validateFromTo('depositPlace', values.depositPlace)) {
        return errors.depositPlace = i18n.t('booking.validation_deposit_place');
    }
};

const vehicleBrand = (values, errors) => {
    if (isEmpty(values.specification.brand)) {
        return errors.specification.brand = i18n.t('booking.required');
    }
};

const vehicleModel = (values, errors) => {
    if (isEmpty(values.specification.model)) {
        return errors.specification.model = i18n.t('booking.required');
    }
};

const vehicleRegistrationNumber = (values, errors) => {
    if (isEmpty(values.specification.registrationNumber)) {
        return errors.specification.registrationNumber = i18n.t('booking.required');
    }
};

const vehicleType = (values, errors) => {
    if (isEmpty(values.vehicleType)) {
        return errors.vehicleType = i18n.t('booking.validation_vehicle_type');
    }
};

const vehicleCount = (values, errors) => {
    if (isEmpty(values.vehicleCount)) {
        return errors.vehicleCount = i18n.t('booking.validation_vehicle_count');
    }

    if (!isNumeric(values.vehicleCount) || values.vehicleCount <= 0) {
        return errors.bags = i18n.t('booking.validation_vehicle_count_zero');
    }
};

const price = (values, errors) => {
    if (isEmpty(values.price)) {
        return errors.price = i18n.t('booking.validation_price');
    }

    if (!isDecimal(values.price)) {
        return errors.price = i18n.t('booking.validation_price_format');
    }

    // if (values.price <= 0) {
    //     return errors.price = "Le montant doit être supérieur à zéro";
    // }
};

const validateFromTo = (field, value) => {
    if(value) {
        const {firstInput, secondInput} = value;

        if (null == firstInput) {
            return false;
        }

        if ('stop' == firstInput.type) {
            return true;
        }

        if (null !== secondInput && 'stop' == secondInput.type) {
            return true;
        }
    }
    return false;
};